import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import ReportsAPI from "./../../../Reports/api/reports_api";
import { formatNumber } from "../../../Utils/Money";

const getUser = async (id) => {
  return new Promise((resolve, reject) => {
    const dataToSend = { id_usuario: id };
    fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataToSend),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        resolve(data.contenido[0]);
      })
      .catch((error) => {
        console.error("Error:", error);
        reject(error);
      });
  });
};

const getBase64ImageFromURL = (url) => {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = (error) => {
      reject(error);
    };

    img.src = url;
  });
};

const loadPlan = async (receipt) => {
  return new Promise((resolve, reject) => {
    var dataClose = { id_plan: receipt.id_plan };
    fetch(process.env.REACT_APP_PUBLIC_URL + "plan/consultar_plan", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataClose),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        resolve(data.contenido[0]);
      })
      .catch((e) => {
        console.log(e);
      });
  });
};

const getRefund = async (recibo) => {
  return new Promise((resolve, reject) => {
    const dataToSend = { id_recibo: recibo };
    fetch(
      process.env.REACT_APP_PUBLIC_URL + "devolucion-recibo-caja/consultar",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataToSend),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        reject(error);
      });
  });
};

const getConsecutive = async () => {
  return new Promise((resolve, reject) => {
    fetch(
      process.env.REACT_APP_PUBLIC_URL + "consecutivos/consultarDevolucion",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        reject(error);
      });
  });
};

export const PrintRefunds = async (
  options
) => {

  const {receipt,admision,valor_devolucion,num_devolucion_recibo,motivo_devolución} = options
  
  const user = JSON.parse(sessionStorage.getItem("usuario"));
  const profile = JSON.parse(sessionStorage.getItem("clinica"));
  const plan = await loadPlan(receipt);
  const userReceipt = await getUser(receipt.usuario);
  const today = moment(new Date()).format("MM-DD-YYYY");
  const third = await ReportsAPI.loadThird(receipt.id_tercero);
  const infoRefund = await getRefund(receipt.id_recibo);
  const consecutive = await getConsecutive();

  const total_devolucion =
    valor_devolucion ??
    infoRefund.reduce(
      (acc, item) => acc + parseInt(item.valor_devolucion || 0),
      0
    );
  const numero_devolucion =
    num_devolucion_recibo ??
    infoRefund[infoRefund.length - 1].num_devolucion_recibo;

  const fechaFac = moment(infoRefund.fecha_emision).format("MM-DD-YYYY");

  let procedures = "";

  try {
    for (let k = 0; k < receipt.servicios.servicios.length; k++) {
      procedures =
        procedures +
        receipt.servicios.servicios[k].codigo +
        ": " +
        receipt.servicios.servicios[k].nombre +
        "\n";
    }
  } catch (error) {
    console.log(error);
  }

  let estado_recibo = receipt.recibo_cancelado == true ? "ANULADO" : "DEVUELTO";

  const devolucion = infoRefund.find((refund)=>{
    if(!!num_devolucion_recibo){      
      return refund.num_devolucion_recibo == num_devolucion_recibo
    }
    
    return refund.firma_digital != null
  })
  const firma_digital = devolucion?.firma_digital;

  const urlFirmaDigital = firma_digital != null ? process.env.REACT_APP_PUBLIC_URL + "firma-digital/" + firma_digital.id_firma_digital + "/" + sessionStorage.getItem("token") : "https://i.postimg.cc/0jznYVsr/prueba.png";

  const responseImagePrint = await getBase64ImageFromURL(urlFirmaDigital)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log({ err });
    });

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    content: [
      {
        margin: [40, 10, 0, 0],
        layout: "noBorders",
        table: {
          widths: ["*", "*", 120],
          body: [
            [
              {
                image: await getBase64ImageFromURL(
                  process.env.REACT_APP_PUBLIC_URL +
                    "clinica/" +
                    profile.id_clinica +
                    "/logo/" +
                    sessionStorage.getItem("token")
                ),
                fit: [100, 50],
              },
              {
                text:
                  profile.nombre +
                  " \n Nit. " +
                  profile.nit +
                  " \n Teléfonos: " +
                  profile.telefono1 +
                  "-" +
                  profile.telefono2 +
                  " " +
                  profile.direccion.direccion,
                style: "head",
              },
              {
                text:
                  "Devolución \n No. " +
                  consecutive[0].prefijo +
                  "-" +
                  numero_devolucion +
                  "\n" +
                  estado_recibo,
                style: "head",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 30, 0, 0],
        table: {
          widths: [168, "*"],
          body: [
            [
              {
                text: "Fecha: " + fechaFac,
                style: "textStyle",
              },
              {
                text: "Recibo de caja: No. " + receipt.num_recibo,
                style: "textStyle",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [168, "*"],
          body: [
            [
              { text: "Devuelto a ", style: "textStyle" },
              {
                text:
                  admision.tip_documento +
                  "-" +
                  admision.num_documento +
                  " " +
                  admision.fullname,
                style: "textStyle",
              },
            ],
            [
              { text: "Cliente ", style: "textStyle" },
              {
                text:
                  plan.tipo == 1
                    ? "Particular - " + third.nombre
                    : plan.tipo == 2
                    ? "Subsidiado - " + third.nombre
                    : plan.tipo == 3
                    ? "Contributivo - " + third.nombre
                    : plan.tipo == 4
                    ? "Regimen Especial - "
                    : "" + third.nombre,
                style: "textStyle",
              },
            ],
            [
              { text: "Valor ", style: "textStyle" },
              {
                text:
                  "$" +
                  formatNumber(total_devolucion) +
                  " Forma de Pago: " +
                  receipt.medio_pago.medio[0].medio,
                style: "textStyle",
              },
            ],
            [
              { text: "Por Concepto de ", style: "textStyle" },
              { text: "Devolución de " + procedures, style: "textStyle" },
            ],
            [
              { text: "Motivo", style: "textStyle" },
              { text: motivo_devolución, style: "textStyle" },
            ],
          ],
        },
      },
      {
        columns: [
          {
            // auto-sized columns have their widths based on their content
            margin: [40, 60, 25, 0],
            layout: "noBorders",
            table: {
              widths: [110],
              headerRows: 1,
              body: [
                [{ text: "" }],
                [
                  {
                    text:
                      "Cajero " +
                      userReceipt.nombres +
                      " " +
                      userReceipt.apellido1,
                    style: "foot",
                  },
                ],
              ],
            },
          },
          {
            // auto-sized columns have their widths based on their content
            margin: [40, 60, 25, 0],
            layout: "headerLineOnly",
            table: {
              widths: [110],
              headerRows: 1,
              body: [
                responseImagePrint != null
                  ? [
                      {
                        image: responseImagePrint,
                        fit:
                          urlFirmaDigital ==
                          "https://i.postimg.cc/0jznYVsr/prueba.png"
                            ? [35, 35]
                            : [80, 80],
                      },
                    ]
                  : [""],
                [{ text: "" }],
                [
                  {
                    text:
                      admision.fullname +
                      " \n" +
                      admision.tip_documento +
                      ": " +
                      admision.num_documento,
                    style: "foot",
                  },
                ],
              ],
            },
          },
        ],
      },
      {
        margin: [0, 10, 0, 0],
        text: "Usuario y fecha de impresión " + user.nombre + " - " + today,
        style: "foot",
      },
    ],
    styles: {
      head: {
        fontSize: 8,
        alignment: "center",
      },
      textStyle: {
        fontSize: 10,
      },
      foot: {
        fontSize: 8,
      },
    },
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.getDataUrl(function (outDoc) {
    document.getElementById("pdfV").src = outDoc;
  });
};
